import React, { useState } from 'react';
import {
  Box, Button, Typography, FormControl, InputLabel, Select, MenuItem,
  ToggleButtonGroup, ToggleButton, Switch, FormControlLabel,
} from '@mui/material';
import DrawerShell from './_drawer/DrawerShell';
import DrawerHeader from './_drawer/DrawerHeader';
import useResponsiveAnchor from './_drawer/useResponsiveAnchor';
import { RADIUS_LIBRARIAN as RADIUS } from '../../theme/tokens';

const DEFAULT_FILTERS = {
  status: 'all',
  has_active_booking: false,
  sort: '',
};

// Sort is applied client-side if the backend ignores the ?sort= param
function StudentFilterDrawer({ open, onClose, value, onApply }) {
  const anchor = useResponsiveAnchor();
  const [local, setLocal] = useState(value || DEFAULT_FILTERS);

  const handleOpen = () => setLocal(value || DEFAULT_FILTERS);

  const handleApply = () => {
    onApply(local);
    onClose();
  };

  const handleReset = () => {
    const reset = { ...DEFAULT_FILTERS };
    setLocal(reset);
    onApply(reset);
    onClose();
  };

  const footer = (
    <Box sx={{ display: 'flex', gap: 1 }}>
      <Button onClick={handleReset} sx={{ borderRadius: RADIUS.md }}>
        Reset
      </Button>
      <Button
        variant="contained"
        onClick={handleApply}
        fullWidth
        sx={{ borderRadius: RADIUS.md, background: 'linear-gradient(135deg, #F26522 0%, #C94E10 100%)' }}
      >
        Apply Filters
      </Button>
    </Box>
  );

  return (
    <DrawerShell
      open={open}
      onOpen={handleOpen}
      onClose={onClose}
      anchor={anchor}
      ariaLabel="Filter students"
      footer={footer}
    >
      <DrawerHeader title="Filter Students" onClose={onClose} />
      <Box sx={{ flex: 1, overflowY: 'auto', px: 2, py: 2 }}>
        <Typography variant="caption" color="text.secondary" fontWeight="600" sx={{ textTransform: 'uppercase', letterSpacing: 0.5 }}>
          Status
        </Typography>
        <Box sx={{ mt: 1, mb: 3 }}>
          <ToggleButtonGroup
            value={local.status}
            exclusive
            onChange={(_, v) => { if (v) setLocal({ ...local, status: v }); }}
            fullWidth
            size="small"
          >
            <ToggleButton value="all">All</ToggleButton>
            <ToggleButton value="active">Active</ToggleButton>
            <ToggleButton value="blocked">Blocked</ToggleButton>
          </ToggleButtonGroup>
        </Box>

        <FormControlLabel
          control={
            <Switch
              checked={local.has_active_booking}
              onChange={(e) => setLocal({ ...local, has_active_booking: e.target.checked })}
            />
          }
          label="Has active booking"
          sx={{ mb: 3 }}
        />

        <FormControl fullWidth>
          <InputLabel>Sort by</InputLabel>
          <Select
            value={local.sort}
            onChange={(e) => setLocal({ ...local, sort: e.target.value })}
            label="Sort by"
          >
            <MenuItem value="">Recently added</MenuItem>
            <MenuItem value="name_asc">Name A–Z</MenuItem>
            <MenuItem value="name_desc">Name Z–A</MenuItem>
          </Select>
        </FormControl>
      </Box>
    </DrawerShell>
  );
}

export default StudentFilterDrawer;
